import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import createRootReducer from './reducers';
import { getHasToken } from './utils/analytics';
import { analyticsMiddleware } from './middlewares/analytics';

const isInBrowser = typeof window !== 'undefined';
// Shared with the router (see components/history-router) so the store can
// mirror the location: see hooks/useRouterStateSync.
export const history = isInBrowser ? createBrowserHistory() : {};

export default initialState => {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const middlewares = [thunk];

  if (getHasToken()) middlewares.push(analyticsMiddleware);

  //if (window.CONFIG.isDevelopment) {
  //  const { createLogger } = require('redux-logger');
  //  const logger = createLogger({
  //    duration: true,
  //    timestamp: false,
  //    collapsed: true,
  //  });
  //  middlewares.push(logger);
  //}

  const store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancer(applyMiddleware(...middlewares)),
  );

  return store;
};
